import _default from "./default";
import memory from "./memory";
import functionPointer from "./function-pointer";
import fibonacci from "./fibonacci";
import objectLiteral from "./object-literal";
import animation from "./animation";
import closures from "./closures";

const examples = {
  Default: _default,
  Memory: memory,
  FunctionPointer: functionPointer,
  Fibonacci: fibonacci,
  "Object Literal": objectLiteral,
  Animation: animation,
  Closures: closures
};

export default examples;



// WEBPACK FOOTER //
// ./examples/index.js